import { render, staticRenderFns } from "./FooterPolicy.vue?vue&type=template&id=8086e876&scoped=true&"
import script from "./FooterPolicy.vue?vue&type=script&lang=ts&"
export * from "./FooterPolicy.vue?vue&type=script&lang=ts&"
import style0 from "./FooterPolicy.vue?vue&type=style&index=0&id=8086e876&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8086e876",
  null
  
)

export default component.exports